/* Floating WhatsApp contact button popup toggle.
   Lightweight Web Component — no dependencies. Mirrors the spirit of back-to-top.js. */
class WhatsappCta extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('[data-whatsapp-toggle]');
    this.popup = this.querySelector('#whatsapp-popup');
    this.closeBtn = this.querySelector('[data-whatsapp-close]');
    this.onDocClick = this.onDocClick.bind(this);
    this.onKey = this.onKey.bind(this);
  }

  connectedCallback() {
    if (!this.toggle || !this.popup) return;
    this.toggle.addEventListener('click', () => this.togglePopup());
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.setOpen(false));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocClick);
    document.removeEventListener('keydown', this.onKey);
  }

  togglePopup() {
    this.setOpen(!this.isOpen());
  }

  isOpen() {
    return this.popup.classList.contains('whatsapp-cta__popup--open');
  }

  setOpen(open) {
    if (open) {
      this.popup.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(() => this.popup.classList.add('whatsapp-cta__popup--open'));
      this.toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
    } else {
      this.popup.classList.remove('whatsapp-cta__popup--open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      // hide after transition so it leaves the tab order
      setTimeout(() => { if (!this.isOpen()) this.popup.hidden = true; }, 220);
    }
  }

  onDocClick(e) {
    if (!this.contains(e.target)) this.setOpen(false);
  }

  onKey(e) {
    if (e.key === 'Escape') this.setOpen(false);
  }
}

if (!customElements.get('whatsapp-cta')) {
  customElements.define('whatsapp-cta', WhatsappCta);
}
